import { useCallback } from "react";

const SIGNS = ["pallor", "icterus", "edema"];

export const usePrescriptionSections = () => {
  const getSectionCount = useCallback((sectionId: string, formValues: any) => {
    switch (sectionId) {
      case 'complaints':
        return formValues.complaints?.filter((c: any) => typeof c.complaint === 'string' && c.complaint.trim()).length || 0;
      case 'medicines':
        return formValues.medicines?.filter((m: any) => (m.brand_name || m.product)?.trim()).length || 0;
      case 'investigations':
        return formValues.investigations?.filter((i: any) => typeof i === 'string' && i.trim()).length || 0;
      default:
        return null;
    }
  }, []);

  const getSectionStatus = useCallback((sectionId: string, formValues: any) => {
    switch (sectionId) {
      case 'complaints':
        return formValues.complaints?.some((c: any) => typeof c.complaint === 'string' && c.complaint.trim());
      // Pallor / icterus / edema are kept in vitals but belong to the Examination section
      case 'vitals':
        return Object.entries(formValues.vitals || {}).some(([k, v]) => !SIGNS.includes(k) && v && v !== 'None');
      case 'examination':
        return (typeof formValues.examination === 'string' && !!formValues.examination.trim())
          || SIGNS.some(k => formValues.vitals?.[k]);
      case 'diagnosis':
        return typeof formValues.diagnosis === 'string' && formValues.diagnosis.trim();
      case 'medicines':
        return formValues.medicines?.some((m: any) => (m.brand_name || m.product)?.trim());
      case 'investigations':
        return formValues.investigations?.some((i: any) => typeof i === 'string' && i.trim());
      case 'advice':
        return typeof formValues.advice === 'string' && formValues.advice.trim();
      case 'notes':
        return typeof formValues.quick_notes === 'string' && formValues.quick_notes.trim();
      case 'next-visit':
        return formValues.next_visit?.date || formValues.next_visit?.time || formValues.next_visit?.notes;
      default:
        if (sectionId.startsWith('custom_')) {
          const value = formValues.custom_fields?.[sectionId];
          return typeof value === 'string' && !!value.trim();
        }
        return false;
    }
  }, []);

  return {
    getSectionCount,
    getSectionStatus,
  };
};